<template>
  <div>
    <modal-noticia @recargar="recargar"> </modal-noticia>

    <b-card no-body>
      <b-row>
        <b-col md="2">
          <b-button
            v-b-tooltip.hover.v-primary
            v-b-modal.modal-nueva-noticia
            title="Nueva Noticia"
            variant="flat-primary"
            class="btn-icon"
          >
            <feather-icon size="22" icon="PlusSquareIcon" />
          </b-button> </b-col
      ></b-row>
    </b-card>
    <b-overlay :show="showLoading" rounded="sm">
      <b-row>
        <b-col v-for="item in listNoticias" :key="item.id" md="3">
          <b-card class="ecommerce-card" no-body>
            <div class="item-img text-center">
              <b-img :src="item.foto_url" class="card-img-top" />
            </div>

            <b-card-body>
              <h6 class="item-name">{{ item.titulo }}</h6>

              <div class="prueba">
                {{ item.descripcion }}
              </div>
            </b-card-body>
            <div class="item-options text-center mb-1">
              <!-- <b-button
                size="sm"
                class="mr-1"
                @click="editarNoticia"
                v-b-tooltip.hover.v-primary
                v-b-modal.modal-nueva-noticia
                variant="outline-secondary"
              >
                <feather-icon icon="Edit3Icon" class="mr-50" />
                <span>Detalle</span>
              </b-button> -->
              <b-button
                variant="primary"
                size="sm"
                @click="eliminarNoticia(item)"
              >
                <feather-icon icon="DeleteIcon" class="mr-50" />
                <span>Eliminar</span>
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
    </b-overlay>
  </div>
</template>

<script>
import Ripple from 'vue-ripple-directive'

import {
  BCard,
  BCardBody,
  //   BCardText,
  BImg,
  BRow,
  BCol,
  BButton,
  //   BFormInput,
  VBTooltip,
  BOverlay,
} from 'bootstrap-vue'
import {
  computed,
  onMounted,
  ref,
  watch,
  // xxx,
  // xxxx,
  // xxx,
} from '@vue/composition-api'
import store from '@/store'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import ModalNoticia from './ModalNoticia.vue'
import { URL } from '../../utils/variables'
import apiCall from '../../utils/apiCall'

export default {
  components: {
    BCard,
    BCardBody,
    // BCardText,
    BImg,
    ModalNoticia,
    BRow,
    BCol,
    BButton,
    BOverlay,
    // BFormInput,
    // VBTooltip,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  setup() {
    const { getApi, postApi } = apiCall()
    const listNoticias = ref([])
    const showLoading = ref(false)
    async function getNoticias(idTorneo) {
      showLoading.value = true
      listNoticias.value = []
      const path = `ApiNoticias/getNoticias/${idTorneo}`
      const data = await getApi(URL, path)
      listNoticias.value = data.noticias
      showLoading.value = false
    }
    const cambioTorneo = computed(
      // eslint-disable-next-line
      () => store.getters['someVariables/getTorneoSeleccionado']
    )

    watch(cambioTorneo, () => {
      getNoticias(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo
      )
    })

    function recargar() {
      getNoticias(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo
      )
      store.commit('someVariables/UPDATE_SHOW_NEW_NOTICIA', false)
    }
    function editarNoticia() {
      // console.log('editar')
    }

    async function eliminarNoticia(item) {
      // console.log('eliminar')
      const path = 'ApiNoticias/deleteNoticia/'
      const dataDelete = {
        id_noticia: item.id_noticia,
        imagen: item.foto,
        video: item.video_url,
        is_default: item.is_default,
      }
      const data = await postApi(URL, path, dataDelete)
      if (data.flag === 'si') {
        this.$toast(
          {
            component: ToastificationContent,
            props: {
              title: 'ELIMINADA con éxito',
              icon: 'AlertCircleIcon',
              variant: 'success',
              solid: true,
            },
          },
          {
            position: 'bottom-center',
            // eslint-disable-next-line
          }
        )
        getNoticias(
          // eslint-disable-next-line
          store.getters['someVariables/getTorneoSeleccionado'].id_torneo
        )
      }
      // console.log(data)
    }
    onMounted(() => {
      // console.log('mounted config')
      getNoticias(
        // eslint-disable-next-line
        store.getters['someVariables/getTorneoSeleccionado'].id_torneo
      )
    })

    return {
      editarNoticia,
      eliminarNoticia,
      getNoticias,
      listNoticias,
      showLoading,
      recargar,
    }
  },
}
</script>

<style>
.prueba {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
}
</style>
